import { receivingCreateRequestComponent } from './createRequest.component';
import { receivingStateName } from '../../../tickets.state';
import { TicketService } from '../../../../ticket/ticket.service';

export const receivingCreateRequestStateName = `${receivingStateName}.createRequest`;

export const receivingCreateRequestState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: receivingCreateRequestStateName,
    url: '/request/create/:ticketId?nachlass',
    params: {
      ticketId: null, // optional
    },
    component: receivingCreateRequestComponent.name,
    data: { requiresAuth: true },
    resolve: {
      ticket: TicketService.ticket({ optional: true }),
      stateIndex: () => 0, // First step for a new receiving request ticket
    },
  });
};
